export const ForecastRegionList = [
    {
        name: 'Prince William Sound',
        id: 0
    },
    {
        name: 'Cook Inlet - Coming Soon',
        id: 1
    },
    {
        name: 'Kodiak - Coming Soon',
        id: 2
    },
    {
        name: 'Southeast - Coming Soon',
        id: 3
    },
    {
        name: 'Bering - Coming Soon',
        id: 4
    },
]